import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { useNavigate } from 'react-router-dom';

function Leaderboard() {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadLeaderboard();
  }, []);

  const loadLeaderboard = async () => {
    try {
      const teamDoc = await getDoc(doc(db, 'teams', auth.currentUser.uid));
      if (teamDoc.exists()) {
        const { players, votes } = teamDoc.data();
        
        const pointsMap = {};
        
        players.forEach(player => {
          pointsMap[player.id] = {
            ...player,
            totalPoints: 0,
            threes: 0,
            twos: 0,
            ones: 0,
          };
        });

        votes.forEach(vote => {
          vote.votes.forEach(v => {
            if (pointsMap[v.playerId]) {
              pointsMap[v.playerId].totalPoints += v.points;
              if (v.points === 3) pointsMap[v.playerId].threes++;
              if (v.points === 2) pointsMap[v.playerId].twos++;
              if (v.points === 1) pointsMap[v.playerId].ones++;
            }
          });
        });

        const sortedLeaderboard = Object.values(pointsMap).sort((a, b) => {
          if (b.totalPoints !== a.totalPoints) {
            return b.totalPoints - a.totalPoints;
          }
          if (b.threes !== a.threes) return b.threes - a.threes;
          if (b.twos !== a.twos) return b.twos - a.twos;
          return b.ones - a.ones;
        });

        setLeaderboard(sortedLeaderboard);
      }
    } catch (error) {
      console.error('Error loading leaderboard:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="header">
        <h1>Leaderboard</h1>
        <button 
          onClick={() => navigate('/')}
          style={{
            background: 'white',
            border: '2px solid white',
            color: '#243665',
            cursor: 'pointer',
            fontSize: '16px',
            padding: '10px 20px',
            borderRadius: '8px',
            fontWeight: '600',
            minWidth: '80px',
            minHeight: '44px',
            touchAction: 'manipulation',
            WebkitTapHighlightColor: 'transparent'
          }}
        >
          Back
        </button>
      </div>

      <div style={{ padding: '20px 0' }}>
        {loading ? (
          <p>Loading...</p>
        ) : leaderboard.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: '40px' }}>
            <p style={{ color: '#666' }}>No votes yet</p>
          </div>
        ) : (
          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '100%' }}>
                <thead>
                  <tr style={{ background: '#f5f5f5' }}>
                    <th style={{ padding: '8px 4px', textAlign: 'left', fontSize: '11px', minWidth: '35px' }}>#</th>
                    <th style={{ padding: '8px 8px', textAlign: 'left', fontSize: '11px', minWidth: '120px' }}>Player</th>
                    <th style={{ padding: '8px 4px', textAlign: 'center', fontSize: '11px', width: '35px' }}>3s</th>
                    <th style={{ padding: '8px 4px', textAlign: 'center', fontSize: '11px', width: '35px' }}>2s</th>
                    <th style={{ padding: '8px 4px', textAlign: 'center', fontSize: '11px', width: '35px' }}>1s</th>
                    <th style={{ padding: '8px 4px', textAlign: 'center', fontSize: '11px', width: '45px' }}>Pts</th>
                  </tr>
                </thead>
                <tbody>
                  {leaderboard.map((player, index) => (
                    <tr key={player.id} style={{ 
                      borderTop: '1px solid #eee',
                      background: index < 3 ? '#f9f9f9' : 'white'
                    }}>
                      <td style={{ padding: '10px 4px', fontSize: '13px' }}>
                        {index === 0 && '🥇'} {index === 1 && '🥈'} {index === 2 && '🥉'} {index > 2 && (index + 1)}
                      </td>
                      <td style={{ padding: '10px 8px' }}>
                        <div style={{ fontWeight: '600', color: '#243665', fontSize: '14px' }}>
                          {player.name}
                        </div>
                        {player.number && (
                          <div style={{ fontSize: '11px', color: '#666' }}>
                            #{player.number}
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '10px 4px', textAlign: 'center', fontSize: '13px' }}>{player.threes}</td>
                      <td style={{ padding: '10px 4px', textAlign: 'center', fontSize: '13px' }}>{player.twos}</td>
                      <td style={{ padding: '10px 4px', textAlign: 'center', fontSize: '13px' }}>{player.ones}</td>
                      <td style={{ padding: '10px 4px', textAlign: 'center', fontWeight: 'bold', color: '#243665', fontSize: '15px' }}>
                        {player.totalPoints}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div className="card">
          <p style={{ fontWeight: 'bold', marginBottom: '8px', color: '#243665' }}>Legend:</p>
          <p style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>3s = Best votes (3 pts)</p>
          <p style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>2s = Second votes (2 pts)</p>
          <p style={{ fontSize: '12px', color: '#666' }}>1s = Third votes (1 pt)</p>
        </div>
      </div>
    </div>
  );
}

export default Leaderboard;
